// Tracks the current active order so the user can always come back to /order-tracking
// even if they navigate away or close the tab.

const KEY = 'wegoo_active_order';

export const saveActiveOrder = (orderId, orderType = 'food') => {
  if (!orderId) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({
      orderId,
      orderType,
      savedAt: Date.now(),
    }));
  } catch (e) {
    console.debug('saveActiveOrder skipped:', e?.message || e);
  }
};

export const getActiveOrder = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    // Auto-expire after 48h to avoid stale banners
    if (!parsed.savedAt || Date.now() - parsed.savedAt > 48 * 3600 * 1000) {
      localStorage.removeItem(KEY);
      return null;
    }
    return parsed;
  } catch (e) {
    return null;
  }
};

export const clearActiveOrder = () => {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {
    console.debug('clearActiveOrder skipped:', e?.message || e);
  }
};
